export const downloads = {
  title: "Downloads Screen",
};
